<div class="wil-content wilcity-archive">
  <section class="wil-section has-page-heading">
    <div class="container news-lists">
      <h1 class="has-text-align-center heading_title__1bzno">{{ pageHeadline }}</h1>

      <div class="news-categories-submenus">
        <ul class="">
          <li><a [routerLink]="'/news/business'">Business</a></li>
          <li><a [routerLink]="'/news/celebrity-news'">Celebrity News</a></li>
          <li><a [routerLink]="'/news/community'">Community</a></li>
          <li><a [routerLink]="'/news/entertainment'">Entertainment</a></li>
          <li><a [routerLink]="'/news/health'">Health</a></li>
          <li><a [routerLink]="'/news/jobs'">Jobs</a></li>
          <li><a [routerLink]="'/news/music'">Music</a></li>
          <li><a [routerLink]="'/news/sport'">Sport</a></li>
          <li><a [routerLink]="'/news/world-news'">World News</a></li>
        </ul>
      </div>

      <div class="">
        <div class="home item thin_divide module">
          <div class="thin-split ccox link-ccox linkro-box bdrcc">
            <h6></h6>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="searchbox_wrap__37JXq searchbox_wrap_news mb-30">
            <div class="searchbox_searchInput__2p4ds">
              <div class="field_module__1H6kT field_style5__3OR3T mb-0 js-field">
                <div class="field_wrap__Gv92k wil-autocomplete-field-wrapper">
                  <div class="field_module__1H6kT field_style2__2Znhe active" posttype="listing">
                    <div id="">
                      <div role="combobox" aria-expanded="false" aria-haspopup="listbox"
                        aria-owns="autosuggest-autosuggest__results" class="hasAttribute">
                        <input [(ngModel)]="queryParams.keyword" type="text" autocomplete="off"
                          placeholder="Search News" class="field_field__3U_Rt" (keyup.enter)="onSubmitSearch()">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="searchbox_searchButton__1c9iK">
              <button (click)="onSubmitSearch()" class="wil-btn wil-btn--primary wil-btn--round wil-btn--md"
                type="button">
                <i class="la la-search"></i> Search
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row cleared lead-alpha">
        <div class="col-md-12 col-xs-12">
          <!-- All news -->
          <div class="row">
            <ng-container *ngIf="allNews == null">
              <div class="inner-spinner">
                <i class="fa fa-spinner fa-spin"></i>
              </div>
            </ng-container>

            <ng-container *ngIf="allNews">
              <ng-container *ngFor="let news of allNews; let index = index">
                <div class="col-xs-12 col-sm-4 col-md-3">
                  <div class="article article-small">


                    <div class="articletext">
                      <a [routerLink]="['/news/details', news.slug]">
                        <img [src]="news.featured_image | imageSrc:'news'">
                      </a>
                      <!-- <div [innerHTML]="news.short_content"></div> -->
                    </div>

                    <h2 class="linkro-darkred title-ellipsis-2">
                      <a [routerLink]="['/news/details', news.slug]">{{news.title}}</a>
                    </h2>

                    <!-- <div class="article-icon-links-container" data-followbutton="DailyMailCeleb"
                      data-social-first-article-links="">
                      <ul class="article-icon-links cleared">
                        <li class="">
                          <a class="comments-link" [routerLink]="['/news/details', news.slug]" fragment="comments">
                            <span class="icon"></span>
                            <span class="linktext">
                              <span class="readerCommentNo bold" rel="9825193">{{news.total_comments}}</span> comments
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div> -->
                  </div>
                </div>

              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>